export const UPLOAD_FILE_START = 'UPLOAD_FILE_START';
export const UPLOAD_FILE_LOADING = 'UPLOAD_FILE_LOADING';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_CANCEL = 'UPLOAD_FILE_CANCEL';
export const UPLOAD_FILE_PROGRESS = 'UPLOAD_FILE_PROGRESS';
export const UPLOAD_FILE_ERROR = 'UPLOAD_FILE_ERROR';